import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { christianToThaiDate } from 'core/service/lib/date'
import VALUES from 'core/data-model/constants/values'

export const LegalConditionDisclaimer = ({ startDate, endDate, isBancAgent }) => {
  return (
    <div id="legal-disclaimer" className="legal group">
      <h3>{MESSAGES.LEGAL_DISCLAIMER}</h3>
      <ol className="nested-counter">
        <li>
          {MESSAGES.POLICY_MAY_CHANGE}
          <ol className="nested-counter">
            <li>{MESSAGES.AGE_HEALTH_OR_CAREER}</li>
            <li>
              {Mustache.render(MESSAGES.FLEXI_HEALTH_INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT, {
                agentName: isBancAgent ? MESSAGES.FLEXI_HEALTH_BANC : MESSAGES.FLEXI_HEALTH_AGENT,
              })}
            </li>
          </ol>
        </li>
        <li>{MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE}</li>
        <li>
          {Mustache.render(MESSAGES.FLEXI_HEALTH_OFFER_SALE_PERIOD, {
            startOffer: christianToThaiDate(startDate),
            endOffer: christianToThaiDate(endDate),
          })}
        </li>
      </ol>
    </div>
  )
}

export const LegalConditionDisclaimerMarketConduct = ({ startDate, endDate, isBancAgent }) => {
  return (
    <div id="legal-disclaimer-market-conduct" className="legal group">
      <h3>{MESSAGES.LEGAL_DISCLAIMER}</h3>
      <ol className="nested-counter">
        <li>
          {Mustache.render(MESSAGES.FLEXI_HEALTH_INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT, {
            agentName: isBancAgent ? MESSAGES.FLEXI_HEALTH_BANC : MESSAGES.FLEXI_HEALTH_AGENT,
          })}
        </li>
        <li>{MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE}</li>
        <li>
          {Mustache.render(MESSAGES.FLEXI_HEALTH_OFFER_SALE_PERIOD, {
            startOffer: christianToThaiDate(startDate),
            endOffer: christianToThaiDate(endDate),
          })}
        </li>
      </ol>
    </div>
  )
}

export const LegalConditionDisclaimerMarketConductNoAddtionalContract = ({ startDate, endDate, isBancAgent }) => {
  return (
    <div id="legal-disclaimer-market-conduct" className="legal group">
      <h3>{MESSAGES.LEGAL_DISCLAIMER}</h3>
      <ol className="nested-counter">
        <li>{MESSAGES.PRELIMINARY_OFFER_MAY_CHANGE}</li>
        <li>
          {Mustache.render(MESSAGES.FLEXI_HEALTH_OFFER_SALE_PERIOD, {
            startOffer: christianToThaiDate(startDate),
            endOffer: christianToThaiDate(endDate),
          })}
        </li>
      </ol>
    </div>
  )
}

export const LegalConditionDisclaimerMarketConductEasyProtect6 = ({ startDate, endDate, isBancAgent }) => {
  return (
    <div id="legal-disclaimer-market-conduct" className="legal group">
      <h3>{MESSAGES.LEGAL_DISCLAIMER}</h3>
      <ol className="nested-counter">
        <li>
          {Mustache.render(MESSAGES.FLEXI_HEALTH_INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT, {
            agentName: isBancAgent ? MESSAGES.FLEXI_HEALTH_BANC : MESSAGES.FLEXI_HEALTH_AGENT,
          })}
        </li>
        <li>{MESSAGES.DISCLAIMER_PRE_SALE_NOTICE}</li>
        <li>{MESSAGES.EASY_PROTECT_6_MARKETING_NOTE}</li>
        <li>
          {Mustache.render(MESSAGES.EASY_PROTECT_6_OFFER_SALE_PERIOD, {
            startOffer: christianToThaiDate(startDate),
            endOffer: christianToThaiDate(endDate),
          })}
        </li>
      </ol>
    </div>
  )
}

export const LegalConditionDisclaimerMarketConductLifeProtectPlus = ({
  startDate,
  endDate,
  isBancAgent,
  productCode,
}) => {
  const UNDER_CODES = [
    VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_UNDER,
    VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_UNDER,
    VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_UNDER,
  ]

  const isUnderGroup = UNDER_CODES.includes(productCode)
  return (
    <div id="legal-disclaimer-market-conduct" className="legal group">
      <h3>{MESSAGES.LEGAL_DISCLAIMER}</h3>
      <ol className="nested-counter">
        <li>
          {Mustache.render(MESSAGES.FLEXI_HEALTH_INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT, {
            agentName: isBancAgent ? MESSAGES.FLEXI_HEALTH_BANC : MESSAGES.FLEXI_HEALTH_AGENT,
          })}
        </li>
        <li>{MESSAGES.DISCLAIMER_PRE_SALE_NOTICE}</li>
        <li>
          {Mustache.render(MESSAGES.LIFE_PROTECT_PLUS_MARKETING_NOTE, {
            plan: isUnderGroup ? 50 : 100,
          })}
        </li>
        <li>
          {Mustache.render(MESSAGES.LIFE_PROTECT_PLUS_OFFER_SALE_PERIOD, {
            startOffer: christianToThaiDate(startDate),
            endOffer: christianToThaiDate(endDate),
            plan: isUnderGroup ? 50 : 100,
          })}
        </li>
      </ol>
    </div>
  )
}
